import {useEffect} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'
import {useLayoutPanels} from '@/shared/context/ChatContext'

/**
 * Files is a lateral panel rather than a page, but `/files?path=…` links were minted by the job
 * history table and may live in bookmarks. Honour them by opening the panel at the requested folder
 * and dropping the user on Results, where their viewers are.
 *
 * Uses an effect + navigate rather than returning <Navigate>, so the panel-open call is guaranteed
 * to run before this component unmounts.
 */
const FilesRouteRedirect = () => {
  const [searchParams] = useSearchParams()
  const {openFilesPanel, openFilesPanelAt} = useLayoutPanels()
  const navigate = useNavigate()

  useEffect(() => {
    const path = searchParams.get('path')
    if (path) {
      openFilesPanelAt(path)
    } else {
      openFilesPanel()
    }
    navigate('/results', {replace: true})
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export {FilesRouteRedirect}
